import { ComponentProps } from "react";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";

type PodcastCardProps = {
  /** The articlee to be displayed in the card */
  cardProps: ComponentProps<typeof Card>;
  /** Optional link parameters for the article */
  linkParams?: URLSearchParams;
};

/**
 * Podcast card component to display a podcast article on homepage.
 * It renders a section with a title and an icon.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=13060-44324&t=5ID3HBaQRGh7o2Lq-0
 */
const PodcastCard = ({
  cardProps,
}: PodcastCardProps): React.ReactElement | null => {
  const CardVariations: CardVariations = {
    title: {
      size: "text-4xl lg:text-4xl",
      color: "text-gray-850",
      extraClass: "mt-4 sm:mt-2 font-lct font-normal -tracking-2% text-center",
    },
    section: {
      extraClass:
        "capitalize font-freightSansPro font-normal text-blue-175 text-base text-center md:text-lg",
    },
    kicker: {
      color: "!text-blue-175",
      extraClass: "text-base font-freightSansPro text-medium text-center",
    },
  };

  return (
    <div
      data-testid="global-top-stories-podcast-card"
      className="relative flex h-full flex-col items-center justify-center gap-1 border border-blue-100 bg-gray-75 p-4 py-15 sm:gap-2"
    >
      <IconFactory
        x={24}
        y={36}
        size={36}
        type={IconTypeEnum.podcastIcon}
        className="text-blue-175"
      />

      <Card {...cardProps} variations={CardVariations} />
    </div>
  );
};

export default PodcastCard;
